import React from "react";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "./Generic/AppCard";
import { AppList, AppListItem } from "./Generic/AppList";

interface Props {
  title: string;
  items: string[];
}

const ListCard = (props: Props) => {
  if (props.items.length === 0) {
    return null;
  }

  const listItems = props.items.map((item, index) => (
    <AppListItem key={index} bulletNumber={index + 1} title={item} />
  ));

  return (
    <AppCard>
      <AppCardHeader>
        <AppCardTitle>{props.title}</AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        <AppList>{listItems}</AppList>
      </AppCardContent>
    </AppCard>
  );
};

export default ListCard;
